import React, { forwardRef } from "react";

export interface ButtonProps extends React.ComponentProps<"button"> {
    width: string;
    height: string;
    children: React.ReactNode;
    isLoading?: boolean;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    ({ width, height, children, isLoading, ...rest }, ref) => {
        return (
            <button
                ref={ref}
                className={`w-${width} h-${height} px-4 py-2 text-white transition duration-150 ease-in-out rounded-full bg-primary`}
                disabled={isLoading}
                {...rest}
            >
                {isLoading ? (
                    <svg
                        className="w-5 h-5 text-white animate-spin"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        ></circle>
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                        ></path>
                    </svg>
                ) : (
                    children
                )}
            </button>
        );
    },
);

export default Button;
